export default __webpack_public_path__ + "static/media/clock.2f8c6727.svg";